import scrollToElement from "scroll-to-element";
import tick from "../helpers/tick";
import { setCSSCustomProperty } from "../helpers/css";
import { isIE } from '../helpers/browser-detection';

const isPage = (slug) => document.body.classList.contains(slug);

export const UIController = {
  init() {
    return new Promise((resolve, reject) => {
      try {
        if (!isIE) {
          this.initMeasurementCheckers();
          this.initAnchorLinksScroller();
          this.checkStoredHash();
        }
        this.highlightCurrentPageLinks();
        resolve();
      } catch (error) {
        reject(error);
      }
    })
  },

  recordWindowDimensions() {
    const { innerWidth, innerHeight } = window;
    setCSSCustomProperty('--vw', innerWidth + 'px');
    setCSSCustomProperty('--vh', innerHeight + 'px');
  },
  recordWpAdminBarHeight() {
    const el = document.getElementById('wpadminbar');
    const height = el ? el.clientHeight : 0;
    setCSSCustomProperty('--wp-admin-bar-height', height + 'px');
    return height;
  },
  recordNavBarHeight() {
    const el = document.getElementById('site-nav');
    const height = el ? el.clientHeight : 0;
    setCSSCustomProperty('--site-nav-height', height + 'px');
    // console.log(height);
    return height;
  },
  initMeasurementCheckers() {
    const handleWindowLoad = () => {
      this.recordWindowDimensions();
      this.recordWpAdminBarHeight();
      this.recordNavBarHeight();
    }
    const handleWindowResize = () => {
      this.recordWindowDimensions();
      this.recordWpAdminBarHeight();
      this.recordNavBarHeight();
    }
    window.addEventListener('load', handleWindowLoad);
    window.addEventListener('resize', handleWindowResize);
  },
  initAnchorLinksScroller() {
    const els = document.querySelectorAll('.section-nav a[href*="#"], .view-main a[href*="#"]');
    const handler = (e) => {
      try {
        const { target } = e;
        const href = target.getAttribute('href');
        const match = href.match(/([^#]*)#(.*)/);

        if (!match) return;

        const pathname = match[1];

        if (!!pathname && pathname !== window.location.pathname) return;
        
        // do not do anything if the thing links to a different page
        const id = match[2];

        if (!id) return;
        // only prevent default if an id is found
        
        e.preventDefault();
        this.scrollToId(id); 
      } catch(e) {
        console.error(e);
        return;
      }
    };
    Array.from(els).forEach(el => {
      el.addEventListener('click', handler);
    })
  },
  async checkStoredHash() {
    if (window.location.hash) {
      await tick(500);
      this.scrollToId(window.location.hash);
      await tick(618);
      window.location.hash = window.location.hash;
    }
  },
  scrollToId(id) {
    if (!id) this.scrollToTop();
    else {
      const offset = -1 * (
        this.recordWpAdminBarHeight() + 
        this.recordNavBarHeight()
      );
      scrollToElement(id[0] === '#' ? id : '#' + id, { offset, ease: 'inOutCube', duration: 618 });
    }
  },
  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  },
  getSiteTitle() {
    return document.body.getAttribute('data-site-title');
  },
  getPageTitle() {
    const titleEl = document.querySelector<HTMLElement>('.page-header__title') || document.querySelector<HTMLElement>('h1') || document.querySelector<HTMLElement>('title');
    const title = titleEl && titleEl.innerText;
    return title || '';
  },
  highlightCurrentPageLinks() {
    const { origin, pathname } = window.location;
    const originRegExp = new RegExp('^' + origin);
    const anchors = document.querySelectorAll('a');
    const pathnameRegExp = new RegExp('^' + pathname);
    Array.from(anchors).forEach(a => {
      if (a.href) {
        const i = a.href.replace(originRegExp, '');
        const matches = a.classList.contains('fuzzy-match') ? i.match(pathnameRegExp) : i === pathname;
        
        if (matches) a.classList.add('active');
      }
    })
  },

}
